import styled from "styled-components";
import { screenSizes } from "../../styles/theme";

export const PortFolioWrapperSection = styled.div``;
export const PortFolioBoxSection = styled.div`
  padding: 2rem 5rem;
  background-color: rgba(253, 249, 238, 1);
  @media (max-width: ${screenSizes.L}px) {
    padding: 1rem;
  }
  button {
    margin: auto;
    display: block;
  }
  ul {
    padding: 0;
    display: flex;
    list-style: none;
    gap: 24px;
    @media (max-width: ${screenSizes.L}px) {
      display: block;
      margin-bottom: 0px;
    }
    li {
      .main_content_box {
        cursor: pointer;
        position: relative;
        span {
          position: absolute;
          top: 0;
          background: #091c0080;
          border: 1px solid rgba(255, 157, 89, 1);
          display: inline-block;
          color: #fff;
          padding: 5px 15px;
          font-size: 12px;
          left: 20px;
          top: 30px;
          border-radius: 50px;
        }
        .botom_content_box {
          position: absolute;
          bottom: 60px;
          left: 20px;
          z-index: 98;
        }
      }
      h4 {
        font-size: 20px;
        color: #fff;
        font-weight: 700;
        margin: 0;
        padding-bottom: 5px;
      }
      h5 {
        font-size: 16px;
        margin: 0;
        color: #fff;
        font-weight: 500;
      }

      &:first-child {
        flex: 1.5 1.5 0;
        padding-top: 100px;
        @media (max-width: ${screenSizes.L}px) {
          padding-top: 0px;
        }
        img {
          width: 100%;
          margin-bottom: 30px;
        }
      }
      &:last-child {
        flex: 1 1 0;
        img {
          width: 100%;
          margin-bottom: 30px;
        }
      }
    }
  }
`;
